<template>
    <div v-if="active" class="replies-stage">
        <div class="reply-items">
            <div class="reply-content" v-for="reply in replies" :key="reply.id">

                <p class="content">{{reply.content}}</p>

                <p class="meta">
                    <span class="from_ame">{{reply.from_name}}</span>
                    <span class="arrow">  回復  </span>
                    <span class="to_name">{{reply.to_name}}</span>
                </p>
                
                <p class="action-box">
                    <span class="time">{{reply.created_at}}</span>
                    <span @click="doReply(reply.from_id, reply.from_name)">回復</span>
                </p>
            </div>
        </div>
        <div class="item fetch-more" v-if="showLoadMore" @click="fetchMore()">
            <div class="fetch-more-reply">加載更多</div>
        </div>
        <div class="reply-form">
            <input type="text" v-model="formData.content" :placeholder="hint" ref="content">
            <button @click="addReply()">回復</button>
        </div>
        <loading v-show="isLoading"></loading>
    </div>
</template>

<script>
    import Loading from '@/views/Loading'
    export default {
        name: "PostReplies",
        props: {
            commentId: Number,
            active: Boolean,
        },
        components:{
            Loading
        },
        data() {
            return {
                replies: [],
                hasGet: false,
                hint: '說點什麼吧...',
                page: 1,
                showLoadMore: false,
                formData: {
                    topic_id: this.$route.params.id,
                    comment_id: this.commentId,
                    from_id: this.$store.state.userInfo.app_user_id,
                    from_name: this.$store.state.userInfo.role_name,
                    to_id: '',
                    to_name: '',
                    content: '',
                },
                isLoading:false
            }
        },
        methods: {
            fetchMore() {
                this.page += 1;
                this.get(this.page);
            },
            get(page = 1) {
                this.hasGet = true;
                let api = `/reply/get/${this.commentId}?page=${page}`;
                this.$http.get(api).then(response => {
                    this.replies.push(...response.data.data);
                    this.showLoadMore = Boolean(response.data.next_page_url);
                })
            },
            doReply(user_id, user_name) {
                
                this.hint = `回復 @'${user_name} :`;
                this.formData.to_id = user_id;
                this.formData.to_name = user_name;
                this.$refs.content.focus(); //input框获取焦点
            },
            addReply() {
                console.log(this.formData.content);
               
                if (this.formData.content) {
                    this.isLoading = true;
                    var topic_id = this.$route.params.id;
                    var api = `https://forum.gamemorefun.net/api/comment/${topic_id}/popNotice`
                    this.$http
                        .get(api)
                        .then((result) => {
                            // console.log(result.data);
                        }).catch((error) => {
                            // console.log(error.response);
                        })

                    this.$http
                        .post('/reply/store', this.formData)
                        .then(response => {
                            this.clear();
                            this.replies.unshift(response.data);
                            this.isLoading = false;
                            
                        });
                }  else {
                    this.$toast('輸入內容為空!');
                }

            },
            clear() {
                this.hint = '說點什麼吧...'
                this.formData.to_id = '';
                this.formData.to_name = '';
                this.formData.content = '';
            }
        },
        watch: {
            active(value) {
                this.clear();
                if (value) {
                    if (!this.hasGet) {
                        this.get();
                    }
                }
            },
        }
    }
</script>

<style scoped>
    .replies-stage {
        font-size: 12px;
        height: auto;
        overflow: hidden;
        width: 100%;
        box-sizing: border-box;
        color: #4c4c4c;
    }

    .reply-content {
        padding: 10px 0;
        border-bottom: 1px solid #ccc;
    }

    .reply-form {
        display: flex;
        flex-direction: row;
        width: 100%;
        position: relative;
        padding: 2% 0 6%;
    }

    .reply-form input {
        width: 90%;
        height: .8rem;
        padding-left: 10px;
        line-height: 35px;
        border-radius: 3px;
        color:#4c4c4c;
        font-size: .3rem;
        background: #d6d6d6;
        text-indent: 3px;
        padding-right: 10px;
    }

    .reply-form button {
        width: 1.7rem;
        height: .8rem;
        line-height: .8rem;
        border-radius: 3px;
        font-size: .3rem;
        color: #ffffff;
        background-color: #fe8124;
        margin-left: -.1rem;
    }

    .meta {
        display: flex;
        flex-direction: row;
    }

    .meta .from_ame, .to_name {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 40%;
        width: auto;
    }
    .meta .from_ame{
        color: #333333;
        font-size:.3rem
    }

    .meta .to_name{
        color: #808080;
        font-size:.28rem
    }

    .meta .arrow {
        display: inline-block;
        padding: 0 5px;
        font-size:.28rem;
        color: #4c4c4c;
    }

    .reply-content .content {
        font-size: .28rem;
        color: #4c4c4c;
        word-break:break-all;
        line-height: 4vh;
        margin-bottom: 10px;
    }

    .reply-content .action-box {
        margin-top: 5px;
        display: flex;
        line-height: 20px;
        justify-content: space-between;
    }

    .fetch-more {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .fetch-more-reply {
        display: inline-block;
        margin: 0.3rem 0;
        font-size: 12px;
        color: green;
        cursor: pointer;
    }
</style>